import { Calendar } from "primereact/calendar";
import React from "react";
import {
  flatFee,
  MixingBearingCost,
  RemixClausesOptions,
  SideArtistClausesOptions,
} from "shared/components/AllDropdownOptions";
import {
  CustomCalendar,
  CustomCheckbox,
  CustomDropDown,
  CustomInput,
  CustomTextArea,
} from "shared/components/allInput";
import formValidation from "utils/validations";

const Remix = ({ data, setData }) => {
  console.log(data, "data")
  const handleChange = ({ name, value }) => {
    const formErrors = formValidation(name, value, data);
    setData((prev) => ({ ...prev, [name]: value, formErrors }));
  };

  const handleCheckboxChange = (name, isChecked) => {
    setData((prev) => {
      const currentClauses = [...(prev.clauses || [])];

      if (isChecked) {
        if (!currentClauses.some((item) => item.name === name)) {
          currentClauses.push({
            name,
            value:
              name === "notice"
                ? prev.notice?.email || ""
                : prev.remedies?.law || "",
          });
        }

        return {
          ...prev,
          clauses: currentClauses,
          ...(name === "notice" &&
            !prev.notice && {
            notice: { email: "" },
          }),
          ...(name === "remedies" &&
            !prev.remedies && {
            remedies: { law: "" },
          }),
        };
      } else {
        const index = currentClauses.findIndex((item) => item.name === name);
        if (index !== -1) currentClauses.splice(index, 1);
        return { ...prev, clauses: currentClauses };
      }
    });
  };

  return (
    <>
      <div className="w-6">
        <h4 className="text-xl">Draft an Agreement</h4>
        <CustomInput
          data={data}
          name="agreementName"
          label="Name of Agreement"
          ignoreLabel
          col={12}
          onChange={handleChange}
        />
      </div>
      <div>
        <h5 className="text-xl font-medium">Primary Artist Name</h5>
        <div className="grid mt-3 align-items-center">
          <CustomInput
            name="fullLegalName"
            data={data}
            col={5}
            onChange={handleChange}
            label="Artist Full Legal Name"
          />
          <div className="col text-center">p/k/a</div>
          <CustomInput
            data={data}
            label="Artist Name"
            col={5}
            name="name"
            onChange={handleChange}
          />
          <div className="md:col-12">
            <h5 className="text-xl font-medium mb-3">Primary Artist Address</h5>
            <label className="text-gray-500 mb-0" htmlFor="">
              Unit Number, Street Number, City, State, Zip Code
            </label>
            <CustomTextArea
              col={12}
              className="w-full "
              rows={5}
              cols={30}
              data={data}
              ignoreLabel
              name="address"
              onChange={handleChange}
            />
          </div>
          <CustomInput
            name="remixerFullLegalName"
            data={data}
            label="Remixer Full Legal Name"
            col={5}
            onChange={handleChange}
          />
          <div className="col text-center">p/k/a</div>
          <CustomInput
            data={data}
            label="Remixer Artist Name"
            col={5}
            name="remixerName"
            onChange={handleChange}
          />
          <div className="md:col-12">
            <h5 className="text-xl font-medium mb-3">Remixer Legal Address</h5>
            <label className="text-gray-500" htmlFor="">
              Unit Number, Street Number, City, State, Zip Code
            </label>
            <CustomTextArea
              className="w-full mt-3"
              rows={5}
              col={12}
              cols={30}
              data={data}
              name="remixerAddress"
              onChange={handleChange}
              ignoreLabel
            />
          </div>
          <div className="md:col-12">
            <label htmlFor="" className="text-xl font-bold">Scope of Work</label>
            <h5 className="text-xl font-medium mb-3 mt-4 ">Edit of Remix</h5>
          </div>
          <CustomInput
            data={data}
            label=" Orignal Release Name"
            col={6}
            name="releaseName"
            onChange={handleChange}
          />
          <CustomInput
            data={data}
            label="No. of Times of Edit"
            col={6}
            name="editNumber"
            onChange={handleChange}
          />
          <CustomDropDown
            options={MixingBearingCost}
            optionLabel="name"
            data={data}
            col={12}
            placeholder="Select"
            name="bearingTheCost"
            onChange={handleChange}
            label="Mixing and Mastering"
          />
          <CustomCalendar
            value={data?.deadline ? new Date(data.deadline) : null}
            label="Delivery Deadline"
            col={6}
            data={data}
            onChange={handleChange}
            name="deadline"
          />
          <CustomInput
            data={data}
            name="remixAudioFormat"
            col={6}
            onChange={handleChange}
            label="Delivery Audio Format"
          />
          <CustomInput
            data={data}
            name="remixFee"
            col={6}
            onChange={handleChange}
            label="Remix Fee"
          />
          <CustomInput
            data={data}
            name="splitPercentage"
            col={6}
            onChange={handleChange}
            label="Royalty Split"
          />
          <CustomInput
            data={data}
            name="remixCredit"
            col={6}
            onChange={handleChange}
            label="Credit"
          />
          <div className="md:col-12">
            <h5 className="text-xl font-medium mb-3">
              Other Clauses to Add/Consider
            </h5>
            <p className="mb-2">
              Add any clauses that may be needed for your contract.
            </p>

            {RemixClausesOptions.map((item) => {
              const clause = data.clauses?.find((c) => c.name === item.name);
              const isChecked = !!clause;

              return (
                <div key={item.name}>
                  <CustomCheckbox
                    name={item.name}
                    label={item.label}
                    checked={isChecked}
                    onChange={({ name, value }) =>
                      handleCheckboxChange(name, value)
                    }
                  />

                  {/* Termination Clause Input */}
                  {item.name === "notice" && isChecked && (
                    <div className="email-input">
                      <CustomInput
                        value={data.notice?.email || ""}
                        data={data}
                        name="email"
                        onChange={({ name, value }) => {
                          setData((prev) => ({
                            ...prev,
                            notice: { email: value },
                            clauses: prev.clauses.map((c) =>
                              c.name === "notice" ? { ...c, value } : c
                            ),
                          }));
                        }}
                        placeholder="Enter Email id"
                        ignoreLabel
                      />
                    </div>
                  )}

                  {/* Governing Law Clause Input */}
                  {item.name === "remedies" && isChecked && (
                    <div className="remedies-input">
                      <CustomInput
                        data={data}
                        value={data.remedies?.law || clause?.value || ""}
                        name="law"
                        onChange={({ name, value }) => {
                          setData((prev) => ({
                            ...prev,
                            remedies: { law: value },
                            clauses: prev.clauses.map((c) =>
                              c.name === "remedies" ? { ...c, value } : c
                            ),
                          }));
                        }}
                        placeholder="Enter Jurisdiction Law"
                        ignoreLabel
                      />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Remix;
